const STORAGE_KEY = 'workloop.channelShowNotifications';
const EVENT_NAME = 'workloop:channel-notif-visibility-changed';

const readMap = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const isChannelNotificationsVisible = (channelId) => {
  if (!channelId) return true;
  const map = readMap();
  return map[String(channelId)] !== false;
};

export const setChannelNotificationsVisible = (channelId, visible) => {
  if (!channelId) return isChannelNotificationsVisible(channelId);
  const map = readMap();
  map[String(channelId)] = Boolean(visible);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // ignore quota
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, {
      detail: { channelId: String(channelId), visible: Boolean(visible) },
    }));
  }
  return Boolean(visible);
};

export const CHANNEL_NOTIFICATION_VISIBILITY_EVENT = EVENT_NAME;
